import React from 'react';

import { GlobeIcon } from '$/images/FontAwesomeIcons';

import { AddOn } from './AddOn';

export class CustomDomains extends AddOn {
  public get shortDescription(): string {
    return 'Host your webinars and landing pages on your website or on any domain you own, thus making it possible to track people more effectively by keeping them on the same domain as they register for and attend your webinars.';
  }

  public get description(): string {
    return `Host your webinars on your own domain to improve registrant tracking, and install the embedded player widget on any page.`;
  }

  public get Icon(): React.FC {
    return GlobeIcon;
  }

  public image(): string | null {
    return require('$/images/logos/custom-domain.png').default;
  }
}
